<template>
  <header
    class="widget-header flex justify-between w-full items-center"
  >
    <div class="assistant-img-wrapper flex items-center">
      <img
        v-if="avatarUrl"
        class="mr-3"
        :src="avatarUrl"
        alt="avatar"
      />
       <div>
        <div
          class="font-medium text-base leading-4 flex items-center text-white pb-1"
        >
          <span v-dompurify-html="title" class="mr-1" />
        </div>
        <div
          class="subtitle pt-1 leading-3 flex items-center"
        >
          <div
            :class="`active-status rounded-full mr-2
              ${isOnline ? 'bg-green-500' : 'hidden'}`"
          ></div>

          {{ replyWaitMessage }}
        </div>
      </div>
    </div>
    <header-actions :show-popout-button="showPopoutButton" />
  </header>
</template>

<script>
import { mapGetters } from 'vuex';

import availabilityMixin from 'widget/mixins/availability';
import nextAvailabilityTime from 'widget/mixins/nextAvailabilityTime';
import FluentIcon from 'shared/components/FluentIcon/Index.vue';
import HeaderActions from './HeaderActions.vue';
import routerMixin from 'widget/mixins/routerMixin';
import darkMixin from 'widget/mixins/darkModeMixin.js';

export default {
  name: 'ChatHeader',
  components: {
    FluentIcon,
    HeaderActions,
  },
  mixins: [nextAvailabilityTime, availabilityMixin, routerMixin, darkMixin],
  props: {
    avatarUrl: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    showPopoutButton: {
      type: Boolean,
      default: false,
    },
    showBackButton: {
      type: Boolean,
      default: false,
    },
    availableAgents: {
      type: Array,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters({
      widgetColor: 'appConfig/getWidgetColor',
    }),
    isOnline() {
      const { workingHoursEnabled } = this.channelConfig;
      const anyAgentOnline = this.availableAgents.length > 0;

      if (workingHoursEnabled) {
        return this.isInBetweenTheWorkingHours;
      }
      return anyAgentOnline;
    },
  },
  methods: {
    onBackButtonClick() {
      this.replaceRoute('home');
    },
  },
};
</script>

<style>
  .widget-header {
    background-color: #098e9f;
    color: white;
    height: 70px;
  }

  .subtitle {
    color: #f8f9fa;
    font-size: 0.625rem;
    line-height: 100%;
  }

  .active-status {
    background-color: #8ce230;
    height: 10px;
    width: 10px;
  }

  .assistant-img-wrapper {
    background-image: url("~widget/assets/images/pattern.svg");
    background-repeat: no-repeat;
    background-position: left center;
    overflow: hidden;
  }

  .assistant-img-wrapper img {
    height: 70px;
  }

  .user-message-input {
    font-size: 12px !important;
    min-height: unset !important;
    height: 52px !important;
  }

  .close-button {
    margin-right: 1rem;
    display: block !important;
  }

  .close-button svg {
    color: white !important;
  }
</style>